import scrollParent from './scroll-parent';
import Wix from './wix-sdk-polyfill';
import { isInWix } from './is-in-wix';
import { isMobile, isEditor } from './wix-sdk-utils';

export const scrollTop = () => {
  if (isMobile() || !isInWix()) {
    scrollTo(0);
  } else {
    Wix.scrollTo(0, 0);
  }
};

export const scrollToAppTop = () => {
  if (isMobile() || !isInWix() || isEditor()) {
    scrollTo(0);
  } else {
    Wix.getBoundingRectAndOffsets(({ offsets: { x, y } }) => Wix.scrollTo(x, y));
  }
};

export default function scrollTo(position) {
  const parent = scrollParent();
  if (typeof parent.scrollTo === 'function') {
    parent.scrollTo(0, position);
  } else {
    parent.scrollTop = position;
  }
}



// WEBPACK FOOTER //
// ./app/services/scroll-to.js